// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page404_wrapper__3duLB","title":"Page404_title__29PAN"};